export const convertValueToString = (
    value: string | number | boolean | undefined,
) => {
    if (typeof value === 'undefined') return '';
    if (typeof value === 'boolean') return value.toString();
    if (typeof value === 'number') return value.toString();
    return value;
};
